export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_05.3ec611c6.jpg";